import type { DiscographyQueryType } from "@/types/discography";
import { orpc } from "@/utils/orpc.client";

import type { FormatFilter, SortOption } from "./artist-discography";

const PAGE_SIZE = 48;

interface ArtistAlbumsQueryOptionsInput {
  artistId: string;
  discographyQueryType: DiscographyQueryType;
  filter?: unknown[];
  format: FormatFilter;
  sort: SortOption;
  search?: string;
}

export function getArtistAlbumsInfiniteQueryOptions(input: ArtistAlbumsQueryOptionsInput) {
  const albumsInput = (pageParam: number) => getArtistAlbumsInput(input, pageParam);

  return orpc.music.getArtistAlbums.infiniteOptions({
    input: albumsInput,
    initialPageParam: 0,
    getNextPageParam: (
      lastPage: { hasMore: boolean },
      _allPages: unknown,
      lastPageParam: number,
    ) => {
      if (!lastPage.hasMore) return undefined;
      return lastPageParam + PAGE_SIZE;
    },
  });
}

function getArtistAlbumsInput(input: ArtistAlbumsQueryOptionsInput, pageParam: number) {
  return {
    id: input.artistId,
    type: input.discographyQueryType,
    format: input.format,
    filter: input.filter?.length ? input.filter : undefined,
    sort: input.sort,
    search: input.search || undefined,
    includeFacets: pageParam === 0,
    limit: PAGE_SIZE,
    offset: pageParam,
  };
}
